/**
 * `/ai-digital-human/create` 兼容跳板(2026-08-07 IA 重构 I1)。
 *
 * 老链接一律转到对应的独立线,**router state 原样带过去** —— 那些预填
 * (scenePreset / recipe / explosive / dhRemake)全靠 state 传,丢了就等于跳空。
 * `replace` 而不是 push:跳板不该在浏览器历史里堆一层(返回键会弹回来再跳一次)。
 */
import { Navigate, useLocation, useSearchParams } from "react-router-dom";

import { DH_LINE_ROUTE } from "./DigitalHumanCreatePage";
import { resolveDhLine } from "../model/dhLineResolve";

export default function DhCreateRedirect() {
  const location = useLocation();
  const [params] = useSearchParams();
  const line = resolveDhLine(location.state, params.get("mode"));
  return <Navigate to={DH_LINE_ROUTE[line]} state={location.state} replace />;
}
